Es ist ein Fehler aufgetreten<br>
<a href="mailto:helpdesk@noteradar.at">helpdesk&#64;noteradar.at</a><br><br>
<button type="button" class="btn btn-info mr-3" (click)="home()">Zur Startseite</button>
